<footer
  id="contact"
  class="contact relative px-4 md:px-20 py-10 md:py-20 m-4 md:m-8 flex flex-col justify-between items-start bg-Black rounded-t-3xl"
>
  <!-- Logo arriba a la izquierda -->
  <div
    class="flex flex-col md:flex-row w-full justify-between items-start md:items-center"
  >
    <div class="flex flex-col items-start">
      <div class="logo mb-4 md:mb-0">
        <img src="/logo.png" alt="Logo" class="h-8 w-auto" />
      </div>

      <!-- Opciones debajo del logo -->
      <div class="flex flex-col md:flex-row gap-4 md:gap-12 mt-4">
        <a
          href="#services"
          class="font-clashg text-lg text-white hover:text-Blue">Servicios</a
        >
        <a
          href="#industries"
          class="font-clashg text-lg text-white hover:text-Blue">Industrias</a
        >
        <a
          href="#about"
          class="font-clashg text-lg text-white hover:text-Blue"
          >Sobre Nosotros</a
        >
        <a href="#faq" class="font-clashg text-lg text-white hover:text-Blue"
          >FAQs</a
        >
        <a
          href="#contact"
          class="font-clashg text-lg text-white hover:text-Blue">Contacto</a
        >
      </div>
    </div>

    <!-- Redes sociales a la derecha -->
    <div class="flex gap-4 md:gap-6 mt-1 md:mt-0 mr-10">
      <a href="https://www.facebook.com" target="_blank">
        <img src="/facebook.png" alt="Facebook" class="h-10 w-10" />
      </a>
      <a href="https://www.linkedin.com" target="_blank">
        <img src="/linkedin.png" alt="LinkedIn" class="h-10 w-10" />
      </a>
    </div>
  </div>

  <!-- Línea horizontal blanca -->
  <hr class="border-t border-white w-full my-6" />

  <!-- Texto debajo de la línea blanca -->
  <div class="flex flex-col sm:flex-row justify-between w-full text-white text-sm mb-10">
    <span class="font-clashg text-lg">Desarrollado por <a href="https://www.aquiladesign.co" target="_blank" class="text-Blue hover:underline">AGUMI Design</a></span>
    <span class="font-clashg text-lg">2024 Bios Ingeniería</span>
  </div>
</footer>
